import { createAsyncThunk } from '@reduxjs/toolkit'
import { IIsMobileInput } from './typings'
import { ServiceConfig } from '../services/config'
import { get } from '../services/crud'
import { toQueryString } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}/PhoneValidation`

export const checkIsMobile = createAsyncThunk<boolean, IIsMobileInput>(
  'phoneNumber/check',
  async (model, thunkApi) => {
    const response = await get(`${baseUrl}/isMobile?${toQueryString(model)}`)
    if (response.ok) {
      return await response.json()
    }
    return thunkApi.rejectWithValue(await response.json())
  },
)
